import React, { useState } from 'react';
import { CustomFileInput, FormGroup, Label } from 'reactstrap';

const AcceptedIssuesEvidenceManager = (props) => {
    const addFile = props.setFiles;
    const position = props.pos;
    const [fileName, setFileName] = useState('');
    const [invalidFile, setInvalidFile] = useState(false);

    const handleFileChange = ({ target: { files } }) => {
        const cancel = !files.length;
        if (cancel) return;

        const [{ size, name }] = files;
        const maxSize = 2097152;

        if (size < maxSize) {
            setFileName(name);
            setInvalidFile(false);
            addFile(position, files[0]);
        } else {
            setFileName('');
            setInvalidFile(true);
        }
    };

    return (
        <FormGroup>
            <Label for="issue-severity">Evidence</Label>
            <CustomFileInput
                type="file"
                id="exampleCustomFileBrowser"
                name="customFile"
                data-testid="evidence-file"
                accept={["image/png", "image/jpg"]}
                label={fileName || 'Choose the evidence file (png, jpg)'}
                onChange={handleFileChange}
                invalid={invalidFile}
            />
        </FormGroup>
    );
};

export default AcceptedIssuesEvidenceManager;
